import { jsx as _jsx } from "react/jsx-runtime";
import { logger } from '@price-pages-agency-cards/src/infrastructure/logger';
import { ErrorBoundary } from '@shared-utils/ui/components/ErrorBoundary';
import { DataProvider } from './DataProvider';
export const DataProviderWrapper = ({ agencyId, agencyIds, postalCode, children, }) => (_jsx(ErrorBoundary, { logger: logger.error, children: _jsx(DataProvider, { agencyId: agencyId, agencyIds: agencyIds, postalCode: postalCode, children: children }) }));
